import dbSubstances from "../data/substances.json";

export const substsanceExistsByMegamixId = (megamixId) => {
  return megamixIdToSubstanceId[megamixId] != null;
}

export const getSubstanceById = (id) => {
  return dbSubstances[id];
}